

/* tslint:disable */




import { FlowchartElementType } from './FlowchartElementType';
import { FlowchartNodeDto } from './FlowchartNodeDto';
import { SelectionBehavior } from './SelectionBehavior';

export class FlowchartSelectionBehaviorDto extends FlowchartNodeDto {
    selectionBehavior?: SelectionBehavior;
    elementType?: FlowchartElementType;

}

